import classNames from 'classnames';
import React, { memo, useRef } from 'react';
import styled from 'styled-components';
import { type CollapsibleProps } from './Collapsible.types';

const Collapsible: React.FC<CollapsibleProps> = memo(({ children, isOpen = true, maxHeight }) => {
  const containerRef = useRef(null);
  const isMaxHeightValid = typeof maxHeight === 'number';
  const style = {
    ...(maxHeight && isOpen ? { maxHeight, height: maxHeight } : {}),
  };

  const titleClass = classNames(
    'collapsible-container',
    { open: isOpen },
    { 'auto-height': !isMaxHeightValid },
    { 'no-padding': maxHeight === 0 },
  );
  return (
    <CollapsibleContainer
      data-testid="collapsible"
      className={titleClass}
      ref={containerRef}
      style={style}
      isMaxHeightValid={isMaxHeightValid}
    >
      {isOpen && children}
    </CollapsibleContainer>
  );
});

interface CollapsibleContainerProps {
  isMaxHeightValid: boolean;
}

// Styled Components
const CollapsibleContainer = styled('section').withConfig({
  shouldForwardProp: (prop) => !['isMaxHeightValid'].includes(prop),
})<CollapsibleContainerProps>`
  display: block;
  opacity: 0;
  overflow: hidden;
  transition:
    max-height 0.25s ease-out,
    opacity 0.25s ease-out;

  &.open {
    opacity: 1;
    overflow: ${({ isMaxHeightValid }) => (isMaxHeightValid ? 'auto' : 'initial')};
    transition:
      max-height 0.25s ease-in,
      opacity 0.25s 0.1s ease-in;

    &.auto-height {
      transition:
        max-height 0.2s ease-in,
        opacity 0.2s 0.05s ease-in;
    }
  }
`;

// Display Name
Collapsible.displayName = 'Collapsible';

export default Collapsible;
